<template>
    <div class="collapsibleContainer relative hiddenOverflow bgInherit" :class="{collapsed : collapsed}"
        :style="collapsed ? 'max-height: ' + maxHeight + ';' : ''">
        <div v-html="content"></div>
        <div class="gold f12 absolutePosition bgInherit" style="right: 0; bottom: 0; padding: 2px 4px;"
             @click="collapsed=!collapsed">
            <template v-if="collapsed">
                展开
                <i class="icon arrowDownIcon"></i>
            </template>
            <template v-else>
                收起
                <i class="icon arrowUpIcon"></i>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "collapsibleContainer",
    props : {
        content : String,
        maxHeight : {
            type : String,
            default : 'none'
        }
    },
    data() {
        return {
            collapsed : true
        }
    }
}
</script>

<style lang="scss" scoped>
.gold {
    color: #C9821A;
}
.arrowDownIcon,
.arrowUpIcon {
    width: 10px; height: 10px;
}
.arrowDownIcon {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABCklEQVQ4je3QPU7DMBiA4Z6hG52w20vA2ClJrwFTlzRXsIRNEvtrHBpUIYZGkSpVYrLVG5gLdG1yjE6WYIBIoP4QoEIMfUf782PZrdap/x2FJ3y0M5OEXy5pfzOPrrKm2Dy+vl/S/uYO4GJr8zZNO4q5pSHIFjyQX2FFPHx8JucvmrlrgOnZzqEMAGvqlYYgm/Mg2YvxQBqCrGbe+iGN0MGbMwCs2TsajbbQgo8SQ5BVzCszgGZ/LmXYVcypDEF2Fvvjen0W+2NDkNXUbY59RDVzKkOwzbkPOQ/g7ZluKcOw+y2sbiJEr0YNwVbdOJWUP8Q+oXSwUnSwmkr5O6xOiEVbiEX7KNipv+8Vt5WCHCY/mWUAAAAASUVORK5CYII=);
}
.arrowUpIcon {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABCklEQVQ4je3QPU7DMBiA4Z6hG52w20vA2ClJrwFTlzRXsIRNEvtrHBpUIYZGkSpVYrLVG5gLdG1yjE6WYIBIoP4QoEIMfUf782PZrdap/x2FJ3y0M5OEXy5pfzOPrrKm2Dy+vl/S/uYO4GJr8zZNO4q5pSHIFjyQX2FFPHx8JucvmrlrgOnZzqEMAGvqlYYgm/Mg2YvxQBqCrGbe+iGN0MGbMwCs2TsajbbQgo8SQ5BVzCszgGZ/LmXYVcypDEF2Fvvjen0W+2NDkNXUbY59RDVzKkOwzbkPOQ/g7ZluKcOw+y2sbiJEr0YNwVbdOJWUP8Q+oXSwUnSwmkr5O6xOiEVbiEX7KNipv+8Vt5WCHCY/mWUAAAAASUVORK5CYII=);
    transform: rotate(180deg);
}
</style>
